/** Avatar initials: first letter of first + last name, upper-cased; "?" if both blank. */
export function getInitials(
    firstName?: string | null,
    lastName?: string | null
): string {
    const initials = [firstName, lastName]
        .map((part) => part?.trim().charAt(0) ?? "")
        .join("")
        .toUpperCase();
    return initials || "?";
}
